import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";
interface MasterCourseDepartmentsState {
    data: any;
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
    action: "list" | null;
}

const initialState: MasterCourseDepartmentsState = {
    data: null,
    loading: "idle",
    error: null,
    action: null,
};

export const getCourseDepartments = createAsyncThunk(
    "get/dnar",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.MASTERS.COURSE_DEPARTMENT_LIST, payload);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

const masterCourseDepartmentsSlice = createSlice({
    name: "dnar",
    initialState,
    reducers: {
        resetMasterCourseDepartments: (state) => {
            state.loading = "idle";
            state.error = null;
            state.action = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getCourseDepartments.pending, (state) => {

            state.loading = "pending";
            state.data = null;
            state.error = null;
            state.action = "list";
        });
        builder.addCase(getCourseDepartments.fulfilled, (state, action) => {

            state.loading = "fulfilled";
            state.data = action.payload;
            state.error = null;
            state.action = "list";
        });
        builder.addCase(getCourseDepartments.rejected, (state, action) => {
            state.loading = "rejected";
            state.error = action.payload as string;
            state.data = null;
            state.action = "list";
        });
    },
});

export const { resetMasterCourseDepartments } = masterCourseDepartmentsSlice.actions;
export default masterCourseDepartmentsSlice.reducer;
